module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"plan":"Plan","content":"Content"},"fr":{"plan":"Plan","content":"Contenu"},"de":{"plan":"Planen","content":"Inhalt"}}')
  delete Component.options._Ctor
}
